// extracted by mini-css-extract-plugin
export var dividerLine = "_7g-3";
export var itemImage = "_7g-9";
export var lightDivider = "_7g-4";
export var modalContent = "_7g-5";
export var modalContentCompact = "_7g-6";
export var productCard = "_7g-a";
export var productImage = "_7g-b";
export var productImageCompact = "_7g-7";
export var productImagePlaceholder = "_7g-c";
export var productImagePlaceholderCompact = "_7g-8";
export var progressBarBackground = "_7g-1";
export var progressBarContainer = "_7g-0";
export var progressBarFill = "_7g-2";